/**
 * Group digits with thousands separators.
 *
 * @example
 * groupDigits('1234.0234') // returns '1,234.0234'
 * groupDigits('12345')     // returns '12,345'
 * groupDigits('-1234.6')   // returns '-1,234.6'
 */
export function groupDigits(value: string): string {
	const [x, ...y] = value.split('.');

	return [x?.replace(/\d(?=(\d{3})+$)/gu, '$&,'), ...y].join('.');
}
